import React from 'react';
import PropTypes from 'prop-types';
import css from './StyledButton.css';

const StyledButton = React.forwardRef((props, ref) => {
  const { className, asLink, inverted, dataRole, ...rest } = props; // Allow combining classNames
  const getClassName = () => {
    const classes = [];
    const defaultClass = asLink ? 'link' : 'button';
    classes.push(css[defaultClass]); // Always have a default class
    if ( inverted ) classes.push(css['inverted']);
    if ( className ) classes.push(className);
    return classes.join(" ");
  };
  return (
    <button ref={ref} data-role={dataRole} className={getClassName()} {...rest}>
      {props.children}
    </button>
  );
});

StyledButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  className: PropTypes.string,
  asLink: PropTypes.bool,
  inverted: PropTypes.bool,
  dataRole: PropTypes.string,
};

export default StyledButton;
